import { render, staticRenderFns } from "./o-notification.vue?vue&type=template&id=ed1ed4ac&scoped=true&"
import script from "./o-notification.vue?vue&type=script&lang=js&"
export * from "./o-notification.vue?vue&type=script&lang=js&"
import style0 from "./o-notification.vue?vue&type=style&index=0&id=ed1ed4ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1ed4ac",
  null
  
)

export default component.exports